/* eslint-disable import/no-cycle */
/* eslint-disable no-unused-vars */
import React from "react";
import PropTypes from "prop-types";
import { Card } from "../Card";
import { CardBuilder, LogoPositions } from "../CardComponents/CardBuilder";
import { HeadingAsElement, HeadingSize } from "../../Heading";
import { CardAsType, CardShape, CardOrientation } from "../CardComponents/CardType/CardType";
import * as styles from "./Promo.module.scss";

const PromoTheme = {
	"#FB344D": "wedding",
	"#00A887": "turquoise",
	"#00A2AD": "beach",
	"#FF6000": "sun",
}; // These are the one from https://app.contentful.com/spaces/h82kzjd39wa1/environments/master/content_types/linkTile/fields

export function mapColorToTheme(color) {
	return PromoTheme[color];
}

const PromoCard = ({
	clickable,
	type,
	shape,
	image,
	orientation,
	logo,
	logoPosition,
	header: heading,
	headingAs,
	headingSize,
	content,
	link,
	button,
	renderImage,
	renderLink,
	color,
}) => {
	const themeColor = mapColorToTheme(color);
	return (
		<CardBuilder
			className={styles.vacation}
			clickable={clickable}
			type="none"
			shape="wing"
			orientation={orientation}
			theme={themeColor}
			images={[image]}
			logo={logo}
			link={link}
			logoPosition={logoPosition}
			renderLink={renderLink}
			renderImage={renderImage}>
			<div className={styles.vacationWrapper}>
				<div className={styles.vacationHead}>
					<Card.Header size={headingSize} as={headingAs} className={styles.vacationHeading}>
						{heading}
					</Card.Header>
					{content && <Card.Content dangerouslySetInnerHTML={{ __html: content }} />}
				</div>
				{link && link?.to && (
					<div>
						<Card.Button
							to={link?.to}
							target={link?.target}
							label={link?.text}
							size="md"
							theme="primary"
							className={styles.vacationButton}
							linkComponentProps={{ renderLink }}>
							{link?.text}
						</Card.Button>
					</div>
				)}
			</div>
		</CardBuilder>
	);
};

export default PromoCard;
export { PromoCard, PromoTheme };

PromoCard.propTypes = {
	header: PropTypes.string.isRequired,
	headingAs: PropTypes.oneOf(Object.keys(HeadingAsElement)),
	headingSize: PropTypes.oneOf(Object.keys(HeadingSize)),
	image: PropTypes.shape({
		source: PropTypes.shape({
			src: PropTypes.string,
			srcSet: PropTypes.string,
			sizes: PropTypes.string,
		}),
		alt: PropTypes.string,
		src: PropTypes.string,
	}),
	logo: PropTypes.shape({
		alt: PropTypes.string,
		src: PropTypes.string,
	}),
	logoPosition: PropTypes.oneOf(Object.keys(LogoPositions)),
	renderImage: PropTypes.func,
	renderLink: PropTypes.func,
	button: PropTypes.shape({
		icon: PropTypes.string,
		iconPlacement: PropTypes.oneOf(["right", "left"]),
		size: PropTypes.oneOf(["md", "lg"]),
		onClick: PropTypes.func,
		text: PropTypes.string,
		to: PropTypes.string,
		target: PropTypes.string,
	}),
	link: PropTypes.shape({
		text: PropTypes.string,
		to: PropTypes.string,
		target: PropTypes.string,
	}),
	content: PropTypes.string,
	orientation: PropTypes.oneOf(Object.keys(CardOrientation)),
	/**
	 * CardBuilder props
	 */
	color: PropTypes.oneOf(Object.keys(PromoTheme)),
	clickable: PropTypes.bool,
	type: PropTypes.oneOf(Object.keys(CardAsType)),
	shape: PropTypes.oneOf(Object.keys(CardShape)),
};

PromoCard.defaultProps = {
	headingAs: HeadingAsElement.h3,
	headingSize: HeadingSize.h1Alt,
	orientation: CardOrientation["horizontal-reverse"],
	logo: null,
	logoPosition: "topRight",
	renderImage: undefined,
	image: null,
	renderLink: undefined,
	button: null,
	link: undefined,
	content: "",
	clickable: true,
	type: "shadow",
	shape: "none",
	color: null,
};
